import { type AppMode } from '@databases/modes';

import { createEmbedModeConfig } from '../modes/embed-mode-config.ts';
import { createMobileModeConfig } from '../modes/mobile-mode-config.ts';
import { createNativeEmbedEditorPluginModeConfig } from '../modes/native-embed-editor-plugin-mode-config.ts';
import { createNativeEmbedModeConfig } from '../modes/native-embed-mode-config.ts';
import { type ModeConfig } from '../modes/types.ts';
import { createDefaultModeConfig } from '../modes/utils/create-default-mode-config.ts';

export { type ModeConfig } from '../modes/types.ts';

export function getModeConfig(mode: AppMode): ModeConfig {
  const modeConfigs: Record<typeof mode, () => ModeConfig> = {
    EMBED: createEmbedModeConfig,
    MOBILE: createMobileModeConfig,
    NATIVE_EMBED: createNativeEmbedModeConfig,
    NATIVE_EMBED_EDITOR_PLUGIN: createNativeEmbedEditorPluginModeConfig,
    STANDALONE: createDefaultModeConfig,
  };

  const config = modeConfigs[mode];

  return config();
}
